// 功能点类型
export async function types () {
  return [
    {name: '教学应用', en_name: 'teaching'},
    {name: '教务应用', en_name: 'admin'},
    {name: '其他', en_name: 'others'},
  ]
}

// 功能点
export async function list () {
  return [
    {name: '作业系统', en_name: 'zuoye', type: 'teaching'},
    {name: '教师管理', en_name: 'admin_teacher', type: 'admin'},
    {name: '学生管理', en_name: 'admin_student', type: 'admin'},
    {name: '部门管理', en_name: 'admin_department', type: 'admin'},
    {name: '班级管理', en_name: 'admin_group', type: 'admin'},
    {name: '活动与通知', en_name: 'activity', type: 'admin'},
    {name: '学期与排课', en_name: 'course_arrangement', type: 'admin'},
    {name: '成果管理', en_name: 'admin_achievement', type: 'admin'},
    {name: '计划收集', en_name: 'admin_plan', type: 'admin'},
    {name: '部门配置', en_name: 'department_config', type: 'others'},
    {name: '部门文件', en_name: 'department_file', type: 'others'},
  ]
}



// WEBPACK FOOTER //
// ./src/api/configuration/funcs.js